const API_URL = "https://orlabeachtennisourinhos.com.br";

export default API_URL;
